import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";

const ModalDetailsProcess = (props) => {
  const { t } = useTranslation();
  const { process, show, handleClose } = props;

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{process.nom}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginTop: 16 }}>
          <h3>{t("public.componentProcess.modalDefinition")}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: process.description
                ? process.description
                : t("public.componentProcess.modalAucuneInformation"),
            }}
          ></div>
        </div>
        <div style={{ marginTop: 16 }}>
          <h3>{t("public.componentProcess.modalProprietaire")}</h3>
          <div>
            {process.owner
              ? process.owner.nom
              : t("public.componentProcess.modalAucuneInformation")}
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <h3>{t("public.componentProcess.modalRisques")}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: process.risk
                ? process.risk
                : t("public.componentProcess.modalAucuneInformation"),
            }}
          ></div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>{t("public.componentProcess.modalFermer")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetailsProcess;
